exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-befragung-tsx": () => import("./../../../src/pages/befragung.tsx" /* webpackChunkName: "component---src-pages-befragung-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-lizenzen-tsx": () => import("./../../../src/pages/lizenzen.tsx" /* webpackChunkName: "component---src-pages-lizenzen-tsx" */),
  "component---src-pages-tageshexagramme-tsx": () => import("./../../../src/pages/tageshexagramme.tsx" /* webpackChunkName: "component---src-pages-tageshexagramme-tsx" */)
}

